var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "season-list-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Seasons")]), _vm.loading ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('p', [_vm._v("Loading seasons...")])]) : _vm.seasons.length === 0 ? _c('div', {
    staticClass: "no-seasons"
  }, [_c('p', [_vm._v("No seasons available at the moment.")])]) : _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.seasons, function (season) {
    return _c('div', {
      key: season.season_id,
      staticClass: "col-md-4 col-sm-6 mb-4"
    }, [_c('div', {
      staticClass: "season-card"
    }, [_c('div', {
      staticClass: "season-image"
    }, [_c('img', {
      attrs: {
        "src": season.banner_image || _vm.defaultImage,
        "alt": season.title
      },
      on: {
        "error": _vm.handleImageError
      }
    }), _c('span', {
      staticClass: "gender-badge",
      class: _vm.getGenderBadgeClass(season.gender)
    }, [_vm._v(" " + _vm._s(_vm.getGenderLabel(season.gender)) + " ")])]), _c('div', {
      staticClass: "season-content"
    }, [_c('h3', [_vm._v(_vm._s(season.title))]), _c('div', {
      staticClass: "season-dates"
    }, [_c('p', {
      staticClass: "season-period"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" " + _vm._s(_vm.formatDate(season.season_start)) + " - " + _vm._s(_vm.formatDate(season.season_end)) + " ")]), _c('p', {
      staticClass: "application-period"
    }, [_c('i', {
      staticClass: "fa fa-clock"
    }), _vm._v(" Registration: " + _vm._s(_vm.formatDate(season.registration_start)) + " - " + _vm._s(_vm.formatDate(season.registration_end)) + " ")])]), _c('p', {
      staticClass: "season-description"
    }, [_vm._v(_vm._s(season.summary))]), season.gender_restriction_message ? _c('div', {
      staticClass: "alert alert-warning"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" " + _vm._s(season.gender_restriction_message) + " ")]) : _vm._e(), _c('div', {
      staticClass: "season-actions"
    }, [season.user_application_status === 'available' ? _c('button', {
      staticClass: "btn btn-universal participate-btn",
      attrs: {
        "disabled": !season.can_register || _vm.isParticipating
      },
      on: {
        "click": function ($event) {
          return _vm.participateInSeason(season);
        }
      }
    }, [_vm.isParticipating ? [_vm._v(" Processing... ")] : season.can_register ? [_vm._v(" Apply Now ")] : [_vm._v(" " + _vm._s(_vm.getDisabledReason(season)) + " ")]], 2) : season.user_application_status === 'under_review' ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-clock"
    }), _vm._v(" Under Review ")]) : season.user_application_status === 'accepted' ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" Accepted ")]) : season.user_application_status === 'declined' ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Declined ")]) : season.user_application_status === 'upcoming' ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" Opens Soon ")]) : _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-lock"
    }), _vm._v(" Registration Closed ")])])])])]);
  }), 0), _vm.pagination.lastPage > 1 ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.pagination.currentPage === 1
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.currentPage - 1);
      }
    }
  }, [_vm._v(" Previous ")])]), _vm._l(_vm.displayPages, function (page) {
    return _c('li', {
      key: page,
      staticClass: "page-item",
      class: {
        active: page === _vm.pagination.currentPage
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.changePage(page);
        }
      }
    }, [_vm._v(" " + _vm._s(page) + " ")])]);
  }), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.pagination.currentPage === _vm.pagination.lastPage
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.pagination.currentPage + 1);
      }
    }
  }, [_vm._v(" Next ")])])], 2)])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }